; (function ($, window, document, undefined) {
    'use strict';
    // nom de librairie à modifier
    Foundation.libs.gravure = {
        name: 'gravure',

        version: '1.0.0',

        settings: {
            callback: function () { }
        },

        svgZooms: [],

        init: function (scope, method, options) {
            // initialisation à conserver
            Foundation.inherit(this, '');
            var self = this;

            // à conserver
            this.bindings(method, options);
        },

        initSvgZoom: function () {
            if (this.svgZooms.length > 0) {
                for (let i = 0; i < this.svgZooms.length; i++) {
                    this.svgZooms[i].destroy();
                }
            }

            var svgs = document.querySelectorAll(".svg-content");

            if (typeof svgs !== undefined) {
                for (let i = 0; i < svgs.length; i++) {
                    this.svgZooms.push(new SvgZoom(svgs[i]));
                }
            }
        },
        getStepClassNames: function (type) {
            if (type == "text") {
                return "-step2a";
            } else if (type == "drawing") {
                return "-step2b";
            }
            return "-step1";
        },
        removeGravure: function (data) {
            var jqxhr = $.getJSON(
                "/ProductAction/RemoveGravure",
                {
                    referenceFormatee: data.referenceFormatee,
                    codeEmplacement: data.codeEmplacement
                }, function (d) {
                    if (d.IsValid) {
                        if (d.IsRefreshIncludedServices) {
                            $(".check-list").before("<h3> MATY à votre service</h3>")
                            $(".check-list").prepend("<li><strong>" + d.NumberOfDayForReturn + " jours</strong> pour changer d'avis</li >");
                            $(".check-list").prepend('<li>Retour <strong>GRATUIT</strong></li>');
                        }

                        // Si CAC disponible sur le produit, on rafraichi la partiel pour mettre à jour le Wording.
                        if ($("#cac-wrapper").length) {
                            $.ajax({
                                url: '/Product/ClickAndCollectProduct',
                                method: 'POST',
                                data: {
                                    product: data.referenceFormatee,
                                    variant: $('#ProductVariant').val()
                                },
                                success: function (result) {
                                    if (result.Success) {
                                        $("#cac-wrapper").html(result.cac);
                                        $(document).foundation('product', 'initCacListeners');
                                    }
                                }
                            });
                        }
                    }
                })
                .always(data.callback)
                .done($('#editEngraving-' + data.codeEmplacement).remove());
        },
        removeGravureFromShoppingCart: function (data) {
            $.ajax({
                url: '/CartAction/RemoveEngraving',
                method: "POST",
                data: {
                    optionId: data.optionId,
                    lineNumber: 0
                },
                success: function (result) {
                    $(document).foundation('cart', 'updateCart', result);
                    Foundation.libs.common.hidePreloader();
                    //$(document).foundation('reveal', 'close');
                },
                beforeSend: function () {
                    Foundation.libs.common.showPreloader();
                },
                always: data.callback
            });
        },
        events: function () {
            var self = this;
            var S = this.S;
            //////////////////////////////////////////////////////////////
            //                          ETAPE1                          //
            //////////////////////////////////////////////////////////////
            $(this.scope)
                .ready(function (event) {
                    //tres important pour eviter le cache pour les requetes JSON
                    $.ajaxSetup({ cache: false });
                })
                .on('click', '.checkbox-gravure', function (e) {
                    //console.log("***** checkbox gravure *****");
                    var $this = $(this);
                    var ref = $('#ReferenceFormatee').val();
                    var codeEmplacement = $(this).attr('data-code-emplacement');
                    var popinwidthclassname = $(this).attr('data-popin-width');
                    if (this.checked) {
                        e.preventDefault();
                        $('#popin-gravure-wrapper').attr('data-mq-class-large', popinwidthclassname);
                        $('#popin-gravure-wrapper').mqClass();
                        $('#popin-gravure-wrapper').foundation('reveal', 'open', {
                            url: '/product/LoadGravureFormEmplacement',
                            data: { referenceFormatee: ref, codeEmplacement: codeEmplacement },
                            success: function (data) {
                            },
                            error: function () {
                            }
                        });
                    }
                    else {
                        var jqxhr = $.getJSON("/ProductAction/RemoveGravure", { referenceFormatee: ref, codeEmplacement: codeEmplacement })
                            .always(function (data) {
                                $this.siblings('.update-gravure').hide();
                            });
                    }
                })
                .on('click', '.checkbox-gravure-inline', function (e) {
                    //console.log("***** checkbox gravure inline *****");
                    var $this = $(this);
                    if ($(this).attr('data-specific-variant')) {
                        $(this).prop("checked", false);
                        $('#erreur-globale .error-text').html("Choisissez l'initiale de votre bijou");
                        $('#erreur-globale').foundation('reveal', 'open');
                    }
                    else {
                        var ref = $(this).attr('data-reference');
                        var variant = $(this).attr('data-variant');
                        var codeEmplacement = $(this).attr('data-code-emplacement');
                        var numeroLigne = $(this).attr('data-line-id');
                        var optionId = $(this).attr('data-option-id');
                        var targetWrapper = $(".personnalisation-form-wrapper");
                        const loadModel = {
                            Reference: ref,
                            Variant: variant,
                            LocationCode: codeEmplacement,
                            ItemId: numeroLigne
                        };

                        if (this.checked) {
                            var self = this;
                            e.preventDefault();

                            $.ajax({
                                url: '/engraving/LoadEngravingPreview',
                                data: loadModel,
                                cache: false,
                                beforeSend: function (data) {
                                    $('#preloader').show();
                                },
                                success: function (result) {
                                    if (result.IsValid) {
                                        if (result.IsPreview) {
                                            var stepClassName = Foundation.libs.gravure.getStepClassNames(result.Type)

                                            $('#engraving-preview-modal').attr('class', function (i, c) {
                                                return c.replace(/(^|\s)-step\S+/g, '');
                                            });
                                            $("#engraving-preview-modal").addClass(stepClassName);
                                            $('#engraving-preview-modal').html(result._Preview);
                                            $('#engraving-preview-modal').foundation('reveal', 'open');

                                            $('#engraving-preview-modal').on('opened.fndtn.reveal', function (e) {
                                                if (e.namespace !== 'fndtn.reveal') {
                                                    return;
                                                }

                                                Foundation.libs.gravure.bindInputsToSvg();
                                                Foundation.libs.gravure.addGravureEvents();
                                                Foundation.libs.gravure.initSvgZoom();
                                            });
                                            $('#engraving-preview-modal').on('close.fndtn.reveal', function (e) {
                                                if (e.namespace !== 'fndtn.reveal') {
                                                    return;
                                                }
                                                document.body.style.overflow = 'visible';
                                            })

                                            document.body.style.overflow = 'hidden';
                                        }
                                        else {
                                            targetWrapper.html(result._EngravingForm).fadeIn();
                                            $(document).foundation('scroll', 'moveTo', $('#personnalisation-form-wrapper-anchor'));
                                        }
                                    }
                                },
                                complete: function (data) {
                                    $('#preloader').fadeOut();
                                }
                            });
                        }
                        else {
                            $.ajax({
                                url: '/ProductAction/RemoveGravure',
                                data: { referenceFormatee: ref, codeEmplacement: codeEmplacement, lineId: numeroLigne, optionId: optionId },
                                beforeSend: function (data) {
                                    $('#preloader').show();
                                },
                                success: function (result) {
                                    if (result.IsValid) {

                                    }

                                },
                                complete: function (data) {
                                    $('#editEngraving-' + codeEmplacement).remove();
                                    $('#preloader').fadeOut();

                                }
                            });

                        }
                    }
                })
                .on("click", '#pictofunction', function (e) {

                    var picto = $(this).attr('data-picto');
                    var imageUrl = "/images/Gravure/pictos/" + picto + ".png";
                    var imageId = $(this).attr('data-name');
                    var pictoName = $(this).attr('data-picto-name');
                    var pictoNameElement = $("#pictoName");
                    var imageElement = document.getElementById(imageId);
                    if (imageElement) {
                        imageElement.setAttribute("href", imageUrl);
                        var inputElement = document.querySelector('.pictoZone');
                        if (inputElement) {
                            inputElement.setAttribute("value", picto);
                            pictoNameElement.removeAttr("hidden");
                            pictoNameElement.text("Pictogramme : " + pictoName);
                        }
                    }
                })
                // CLICK SUR BOUTON UPLOAD GRAVURE
                .on("click", '#bt-upload-handwrittenEngraving-file', function (e) {
                    e.preventDefault();

                    // Checking whether FormData is available in browser  
                    if (window.FormData !== undefined) {

                        var fileUpload = $("#Upload").get(0);
                        var files = fileUpload.files;

                        // Create FormData object  
                        var fileData = new FormData();

                        // Looping over all files and add it to FormData object  
                        for (var i = 0; i < files.length; i++) {
                            fileData.append(files[i].name, files[i]);
                        }

                        // Adding one more key to FormData object  
                        fileData.append('productReference', $(this).attr('data-productReference'));
                        fileData.append('locationCode', $(this).attr('data-locationCode'));
                        fileData.append('origin', $(this).attr('data-origin'));
                        if ($(this).attr('data-itemid') != null)
                            fileData.append('itemid', $(this).attr('data-itemid'));

                        $.ajax({
                            url: '/Engraving/SubmitFileToEngrave',
                            type: "POST",
                            contentType: false, // Not to set any content header  
                            processData: false, // Not to process data  
                            data: fileData,
                            success: function (result) {
                                Foundation.libs.gravure.successSubmitEngraving(result);
                            },
                            error: function (err) {
                                Foundation.libs.common.hidePreloader();
                                alert(err.statusText);
                            },
                            beforeSend: function () {
                                Foundation.libs.common.showPreloader();
                            }
                        });
                    } else {
                        alert("FormData is not supported.");
                    }

                    //document.body.style.overflow = 'visible';
                })

                .on('click', '.update-gravure-inline', function (e) {
                    console.log("***** update gravure inline *****");
                    e.preventDefault();
                    var ref = $('#Reference').val();
                    var codeEmplacement = $(this).attr('data-code-emplacement');
                    //var popinwidthclassname = $(this).attr('data-popin-width');

                    //$('#popin-gravure-wrapper').attr('data-mq-class-large', popinwidthclassname);
                    //$('#popin-gravure-wrapper').mqClass();
                    //$('#popin-gravure-wrapper').foundation('reveal', 'open', {
                    //    url: '/product/LoadGravureFormEmplacement',
                    //    data: { referenceFormatee: ref, codeEmplacement: codeEmplacement },
                    //    success: function (data) {
                    //        console.log("1 fois");
                    //    },
                    //    error: function () {
                    //    }
                    //})
                    var targetWrapper = $(".personnalisation-form-wrapper");
                    var lineId = $(this).attr('data-line-id');
                    var isModif = "";
                    if (lineId == null) {
                        isModif = "non";
                    }
                    $.ajax({
                        url: '/product/LoadGravureFormEmplacement',
                        data: { referenceFormatee: ref, codeEmplacement: codeEmplacement, isModif: isModif, template: "inline", },
                        cache: false,
                        dataType: "html",
                        beforeSend: function (data) {
                            $('#preloader').show();
                        },
                        success: function (data) {
                            targetWrapper.html(data).fadeIn();
                            $(document).foundation('scroll', 'moveTo', $('#personnalisation-form-wrapper-anchor'));
                        },
                        complete: function (data) {
                            $('#preloader').fadeOut();
                        }
                    });
                })
                .on('click', '.update-gravure', function (e) {
                    console.log("***** update gravure *****");
                    e.preventDefault();
                    var ref = $('#ReferenceFormatee').val();
                    var codeEmplacement = $(this).attr('data-code-emplacement');
                    var popinwidthclassname = $(this).attr('data-popin-width');

                    $('#popin-gravure-wrapper').attr('data-mq-class-large', popinwidthclassname);
                    $('#popin-gravure-wrapper').mqClass();
                    $('#popin-gravure-wrapper').foundation('reveal', 'open', {
                        url: '/product/LoadGravureFormEmplacement',
                        data: { referenceFormatee: ref, codeEmplacement: codeEmplacement },
                        success: function (data) {
                            console.log("1 fois");
                        },
                        error: function () {
                        }
                    })
                })
                .on('click touchend', '.upload-file', function (e) {
                    // Au click sur le fake bouton file on simule le click sur le vrai bouton file qui est plus petit...
                    e.preventDefault();
                    $('#PieceJointe').trigger('click');
                })
                .on('change', '#PieceJointe', function () {
                    //var filename = $(document).foundation('common', 'GetFileName', $(this));
                    var filename = Foundation.libs.common.getFileName($(this));
                    var filesize = Foundation.libs.common.getSizeUploadedFile($(this));

                    var maxfilesize = $('#hMaxUploadGravure').val();

                    if (filename != null) {
                        if (!filename.match('jpg|jpeg|gif|png$')) {
                            $('#PieceJointeCustomerFileName').val('');

                            $('#upload-section').hide();
                            $('#upload-information-section').show();
                            $('#txtAvecPJ').html('nous en prenons pas en compte ce type de fichier (' + filename + ')');
                            $('#txtSansPJ').css('display', 'block');
                            $('#txtSansPJ').css('display', 'none');
                        }
                        else if (filesize > maxfilesize) {
                            $('#PieceJointeCustomerFileName').val('');

                            $('#upload-section').hide();
                            $('#upload-information-section').show();
                            $('#txtAvecPJ').html('le fichier que vous avez choisi est trop volumineux');
                            $('#txtSansPJ').css('display', 'block');
                            $('#txtSansPJ').css('display', 'none');
                        }
                        else {
                            $('#upload-section').hide();
                            $('#upload-information-section').show();
                            $('#txtAvecPJ').html('Votre fichier : ' + filename);
                            $('#txtSansPJ').css('display', 'block');
                            $('#txtSansPJ').css('display', 'none');
                        }
                    }
                    else {
                        $('#PieceJointeCustomerFileName').val('');

                        $('#upload-information-section').hide();
                        $('#upload-section').show();
                        $('#txtAvecPJ').css('display', 'none');
                        $('#txtSansPJ').css('display', 'block');
                    }
                })
                .on('click', '.remove-uploaded-file', function (e) {
                    e.preventDefault();
                    $('#PieceJointeCustomerFileName').val('');

                    $('#upload-information-section').hide();
                    $('#upload-section').show();
                })
                .on('click', '.bt-font-family-choice', function (e) {
                    var target = e.currentTarget;
                    var form = document.getElementById('form-submit-engraving');
                    var reference = form.elements['Reference'].value;
                    var variant = form.elements['Variant'].value;
                    var locationCode = form.elements['LocationCode'].value;
                    var previewContext = form.elements['PreviewContext'].value;
                    var itemId = form.elements['ItemId'].value;
                    var selectedFont = target.dataset["fontfamily"];
                    var templateId = target.dataset["templateid"];
                    var allInputs = document.querySelectorAll('.engraving-zone-text-input');
                    var zones = [];

                    for (var i = 0; i < allInputs.length; i++) {
                        var zone = {
                            ZoneId: $(allInputs[i]).data("zone-id"),
                            Text: $(allInputs[i]).val(),
                            MaxCharSize: $(allInputs[i]).data("max-char-size")
                        }

                        zones.push(zone);
                    }

                    const changeModel = {
                        Reference: reference,
                        Variant: variant,
                        LocationCode: locationCode,
                        PreviewContext: previewContext,
                        ItemId: itemId,
                        FontFamily: selectedFont,
                        TemplateId: templateId,
                        Zones: zones
                    };

                    var self = this;

                    $.ajax({
                        type: 'POST',
                        url: '/engraving/ChangeTemplateFontFamily',
                        data: changeModel,
                        beforeSend: function () {
                            Foundation.libs.common.showPreloader();
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                var stepClassName = Foundation.libs.gravure.getStepClassNames("text");
                                if (result.IsCart === false) {

                                    $('#engraving-preview-modal').html(result._EngravingPreview);
                                    $('#engraving-preview-modal').attr('class', function (i, c) {
                                        return c.replace(/(^|\s)-step\S+/g, '');
                                    });
                                    $("#engraving-preview-modal").addClass(stepClassName);

                                    Foundation.libs.gravure.initSvgZoom();
                                } else {
                                    $('#product-engraving-popin').html(result._EngravingPreview);
                                    $('#product-engraving-popin').find(".o-engraving").attr('class', function (i, c) {
                                        return c.replace(/(^|\s)-step\S+/g, '');
                                    });
                                    $('#product-engraving-popin').find(".o-engraving").addClass(stepClassName);
                                    //Foundation.libs..addGravureEvents();
                                }
                                Foundation.libs.gravure.addGravureEvents();
                                Foundation.libs.gravure.bindInputsToSvg();

                            }
                            Foundation.libs.common.hidePreloader();
                        },
                        failure: function () {
                            Foundation.libs.common.hidePreloader();
                        }
                    });
                })
                .on('click', '.update-engraving-with-preview', function (e) {
                    var ref = $(this).attr('data-reference');
                    var variant = $(this).attr('data-variant');
                    var codeEmplacement = $(this).attr('data-code-emplacement');
                    var fontFamily = $(this).attr('data-font-family');
                    var loadModel = {
                        Reference: ref,
                        Variant: variant,
                        LocationCode: codeEmplacement,
                        FontFamily: fontFamily
                    }

                    $.ajax({
                        url: '/engraving/LoadEngravingPreview',
                        data: loadModel,
                        cache: false,
                        beforeSend: function (data) {
                            $('#preloader').show();
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                var stepClassName = Foundation.libs.gravure.getStepClassNames(result.Type);
                                $('#engraving-preview-modal').attr('class', function (i, c) {
                                    return c.replace(/(^|\s)-step\S+/g, '');
                                });
                                $("#engraving-preview-modal").addClass(stepClassName);

                                $('#engraving-preview-modal').html(result._Preview);
                                $('#engraving-preview-modal').foundation('reveal', 'open');

                                $('#engraving-preview-modal').on('opened.fndtn.reveal', function (e) {
                                    Foundation.libs.gravure.bindInputsToSvg();
                                    Foundation.libs.gravure.addGravureEvents();
                                    Foundation.libs.gravure.initSvgZoom();
                                    if (stepClassName == "-step1") {
                                        var inputElement = document.querySelector('.pictoZone');
                                        if (inputElement && inputElement.getAttribute("value") != "") {
                                            var infosElement = document.querySelector('div[data-picto="' + inputElement.getAttribute("value") + '"]');
                                            var pictoName = infosElement.getAttribute("data-picto-name");
                                            var pictoNameElement = $("#pictoName");
                                            var imageElement = document.getElementById("SvgImg0001");
                                            var imageUrl = "/images/Gravure/pictos/" + inputElement.getAttribute("value") + ".png";
                                            if (imageElement) {
                                                imageElement.setAttribute("href", imageUrl);
                                                pictoNameElement.removeAttr("hidden");
                                                pictoNameElement.text("Pictogramme : " + pictoName);
                                            }
                                        }
                                    }
                                });
                                $('#engraving-preview-modal').on('close.fndtn.reveal', function (e) {
                                    console.log(e);
                                    document.body.style.overflow = 'visible';
                                })

                                document.body.style.overflow = 'hidden';
                            }
                        },
                        complete: function (data) {
                            $('#preloader').fadeOut();
                        }
                    });
                })
                .on('click', '.update-engraving-with-preview-cart', function (e) {
                    var ref = $(this).attr('data-reference');
                    var variant = $(this).attr('data-variant');
                    var codeEmplacement = $(this).attr('data-code-emplacement');
                    var fontFamily = $(this).attr('data-font-family');
                    var isFromCart = true;
                    var loadModel = {
                        Reference: ref,
                        Variant: variant,
                        LocationCode: codeEmplacement,
                        FontFamily: fontFamily,
                        IsFromCart: isFromCart

                    }
                    console.log(loadModel);

                    $.ajax({
                        url: '/engraving/LoadEngravingPreview',
                        data: loadModel,
                        cache: false,
                        beforeSend: function (data) {
                            $('#preloader').show();
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                var stepClassName = Foundation.libs.gravure.getStepClassNames(result.Type);
                                $('#engraving-preview-modal').attr('class', function (i, c) {
                                    return c.replace(/(^|\s)-step\S+/g, '');
                                });
                                $("#engraving-preview-modal").addClass(stepClassName);

                                $('#engraving-preview-modal').html(result._Preview);
                                $('#engraving-preview-modal').foundation('reveal', 'open');

                                $('#engraving-preview-modal').on('opened.fndtn.reveal', function (e) {
                                    Foundation.libs.gravure.bindInputsToSvg();
                                    Foundation.libs.gravure.addGravureEvents();
                                    Foundation.libs.gravure.initSvgZoom();


                                });
                                $('#engraving-preview-modal').on('close.fndtn.reveal', function (e) {
                                    console.log(e);
                                    document.body.style.overflow = 'visible';
                                })

                                document.body.style.overflow = 'hidden';
                            }
                        },
                        complete: function (data) {
                            $('#preloader').fadeOut();
                        }
                    });
                })
                .on("click", ".o-engraving__close", function (e) {
                    console.log(Foundation.libs.gravure.initialEngravingHtmlFromCart);
                    $(e.currentTarget).parents(".m-gravure").html(Foundation.libs.gravure.initialEngravingHtmlFromCart);

                })
                .on('click', ' .cancel-update-cart-engraving', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    var target = e.currentTarget;
                    var itemId = $(target).data("item-id");

                    $.ajax({
                        type: 'POST',
                        url: '/engraving/CancelUpdateEngravingFromCart',
                        data: { itemId: itemId },
                        beforeSend: function () {
                            Foundation.libs.common.showPreloader();
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                $('#cart-item-engravings-' + result.ItemId).html(result._Engravings);
                                Foundation.libs.common.hidePreloader();
                            }
                        },
                        failure: function () {
                            Foundation.libs.common.hidePreloader();
                        }
                    });
                })
                .on('click', '.engraving-tab', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    var target = e.currentTarget;
                    var contentTarget = target.firstElementChild.hash;
                    var allTabs = document.querySelectorAll('.engraving-tab');
                    var allContents = document.querySelectorAll('.engraving-tab-content');
                    var form = document.getElementById("form-submit-engraving");

                    for (var i = 0; i < allTabs.length; i++) {
                        if (allTabs[i].classList.contains("active")) {
                            $(allTabs[i]).removeClass("active");
                        }
                    }

                    for (var i = 0; i < allContents.length; i++) {
                        if (allContents[i].classList.contains("active")) {
                            $(allContents[i]).removeClass("active");
                        }
                    }

                    $(target).addClass("active");
                    $(contentTarget).addClass("active");

                    form.elements['SelectedTemplateId'].value = contentTarget.replace("#template-", "");
                })
                .on('submit', '#form-submit-engraving', function (e) {

                    for (var i = 0; i < e.currentTarget.elements.length; i++) {
                        if (e.currentTarget.elements[i].classList.contains("engraving-zone-text-input")) {
                            var value = e.currentTarget.elements[i].value.toString().replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');

                            e.currentTarget.elements[i].value = value;
                        }
                    }
                })
                .on('change', '.engraving_date', function (e) {
                    Foundation.libs.gravure.refreshSVGZddn($(e.currentTarget).attr('id'))
                })
                .on('change', '.engraving_time', function (e) {
                    Foundation.libs.gravure.refreshSVGZhdn($(e.currentTarget).attr('id'));
                })
                .on('keyup keydown change', '.engraving_custom', function (e) {
                    Foundation.libs.gravure.refreshSVGZcustom($(e.currentTarget).attr('id'))
                });

        },

        reflow: function () {
            this.events();
        },
        addGravureEvents: function () {

            var fileInput = new FileInput(".js-upload", {
                onChange: function () {
                    $(".o-engraving__input-after").show();
                    $(".o-engraving__input-before").hide();
                    //console.log("CHANGE")

                    $(".o-engraving").find(".engraving-zone-text-input").each(function () {
                        console.log($(this));
                        $(this).val("");
                        $(this).trigger("keyup");
                        $(this).get(0).dispatchEvent(new Event('keyup'));
                    });
                },
                onRemove: function () {
                    $(".o-engraving__input-after").hide();
                    $(".o-engraving__input-before").show();
                },
                onInit: function () {
                    var _this = this;
                    $('.js-delete-button').on("click", function (e) {
                        e.preventDefault();
                        _this.removeFile();
                    })
                }
            });
            $(".o-engraving").find(".engraving-zone-text-input").on("keydown", function () {
                fileInput.removeFile();
            })
            $(".js-nextStep").click(function (e) {
                e.preventDefault();
                var className = $(this).data("step");

                if (className == "step2a") {
                    var inputElement = document.querySelector('.pictoZone');
                    if (inputElement && inputElement.getAttribute("value") != "") {
                        inputElement.setAttribute("value", "");
                        var imageElement = document.getElementById("SvgImg0001");
                        imageElement.setAttribute("href", "/images/Gravure/pictos/V00.png");
                        var pictoNameElement = $("#pictoName");
                        pictoNameElement.text("");
                        pictoNameElement.attr("hidden", true);
                    }
                }
                else if (className == "step2c") {
                    $(".o-engraving").find(".engraving-zone-text-input").each(function () {
                        $(this).val("");
                        $(this).trigger("keyup");
                        $(this).get(0).dispatchEvent(new Event('keyup'));
                    });

                    let pictosSlider = $('#engraving-step2c .o-engraving__row');
                    let colsPicto = pictosSlider.find('.o-engraving__col');
                    console.log(colsPicto);
                    if (colsPicto.length > 4) {

                        if (colsPicto.length % 4 !== 0) {
                            let nbColsToAdd = 4 - colsPicto.length % 4;
                            for (let i = 0; i < nbColsToAdd; i++) {
                                let emptyCol = jQuery('<div>', {
                                    class: "o-engraving__col -empty",
                                });

                                emptyCol.appendTo($('.o-engraving__pictos .o-engraving__row'))
                            }
                        }

                        pictosSlider.owlCarousel({
                            nav: true,
                            navText: ['4', '5'],
                            loop: true,
                            mouseDrag: false,
                            touchDrag: true,
                            lazyLoad: false,
                            items: 4,
                            dots: true,
                            dotsContainer: '#dots',
                            autoWith: true,
                            slideBy: 4,
                        });

                        let dotsContainer = $('#dots');

                        dotsContainer.appendTo(pictosSlider);

                        const dots = dotsContainer.find(".item");

                        dots.on('click', (e) => {
                            const target = $(e.currentTarget)
                            pictosSlider.trigger("to.owl.carousel", target.data("index"))
                        })
                    } else {
                        $('#dots').hide();
                    }
                }
                $(".o-engraving").attr('class', function (i, c) {
                    return c.replace(/(^|\s)-step\S+/g, '');
                });
                $(".o-engraving").addClass("-" + className)
            })
            $(".engraving-text-input-test-emoji").on("input", (e) => {
                // On test s'il y a un emoji dans la zone de saisie, s'il y en a, on le vire
                const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
                const t = e.currentTarget;
                if (regex.test(t.value)) {
                    t.value = t.value.replace(regex, '');
                }
            })
        },

        bindInputsToSvg: function () {
            var allInputs = document.querySelectorAll('.engraving-zone-text-input');
            if (allInputs.length > 0) {
                for (var i = 0; i < allInputs.length; i++) {
                    var templateId = $(allInputs[i]).data("template-id");
                    var tspanId = $(allInputs[i]).data("tspan-id");
                    var isAllCaps = $(allInputs[i]).data("is-all-caps") === "True";
                    var template = document.querySelector("#engraving-preview-visual-" + templateId);
                    var tspan = template.querySelector("#" + tspanId);
                    var currentInputValue = $(allInputs[i]).val();

                    if (isAllCaps) {
                        currentInputValue = currentInputValue.toUpperCase();
                    }

                    $(tspan).html(currentInputValue);

                    if (i === 0) {
                        allInputs[0].focus();
                        $(allInputs[0]).val('');
                        $(allInputs[0]).val(currentInputValue);
                    }
                }

                for (var i = 0; i < allInputs.length; i++) {
                    allInputs[i].addEventListener('keyup', function (e) {
                        var target = $(e.currentTarget);
                        var templateId = target.data("template-id");
                        var tspanId = target.data("tspan-id");
                        var isAllCaps = target.data("is-all-caps") === "True";
                        var template = document.querySelector("#engraving-preview-visual-" + templateId);
                        var tspan = template.querySelector("#" + tspanId);
                        var text = tspan.closest("text");
                        var svg = text.closest("svg");
                        var value = e.currentTarget.value.toString().replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');

                        if (isAllCaps) {
                            value = value.toUpperCase();
                        }

                        tspan.textContent = value;
                        svg.removeChild(text);
                        svg.appendChild(text);
                    });
                }
            }
        },
        initialEngravingHtmlFromCart: "",
        successShowEngravingFromCart: function (result) {
            if (result.IsValid) {
                if (result.IsRedirect) {
                    window.location.href = result.Redirect;
                } else {
                    //console.log($('#m-gravure-container-' + result.ItemId).html());
                    //Foundation.libs.gravure.initialEngravingHtmlFromCart = $('#' + result.ItemId).html();
                    //$('#' + result.ItemId).html(result._Preview);
                    //$('#' + result.ItemId).addClass("-open");      
                    Foundation.libs.cartresume.modifyEngravingPopin(result);

                    Foundation.libs.gravure.bindInputsToSvg();
                    Foundation.libs.common.hidePreloader();
                    Foundation.libs.gravure.reflow();
                    Foundation.libs.gravure.addGravureEvents();
                    Foundation.libs.gravure.initSvgZoom();

                    var stepClassName = Foundation.libs.gravure.getStepClassNames(result.Type)
                    if (stepClassName == "-step1") {
                        var inputElement = document.querySelector('.pictoZone');
                        if (inputElement && inputElement.getAttribute("value") != "") {
                            var infosElement = document.querySelector('div[data-picto="' + inputElement.getAttribute("value") + '"]');
                            var pictoName = infosElement.getAttribute("data-picto-name");
                            var pictoNameElement = $("#pictoName");
                            var imageElement = document.getElementById("SvgImg0001");
                            var imageUrl = "/images/Gravure/pictos/" + inputElement.getAttribute("value") + ".png";
                            if (imageElement) {
                                imageElement.setAttribute("href", imageUrl);
                                pictoNameElement.removeAttr("hidden");
                                pictoNameElement.text("Pictogramme : " + pictoName);
                            }
                        }
                    }
                }
            }
        },

        successSubmitEngraving: function (result) {
            if (result.IsValid) {
                if (result.IsUpdateCart === false && result.IsPopinConfirmation === false) {
                    $('#engraving-preview-modal').foundation('reveal', 'close');
                    document.body.style.overflow = 'visible';
                    $('#engraving-input-checkbox-wrapper').html(result._EngravingChoices);

                    if (result._IncludedServices != null && result._IncludedServices.length > 0) {
                        $('.included-services').html(result._IncludedServices);
                    }

                    // Si CAC disponible sur le produit, on rafraichi la partiel pour mettre à jour le Wording.
                    if ($("#cac-wrapper").length) {
                        $.ajax({
                            url: '/Product/ClickAndCollectProduct',
                            method: 'POST',
                            data: {
                                product: $('#ProductRef').val(),
                                variant: $('#ProductVariant').val()
                            },
                            success: function (result) {
                                if (result.Success) {
                                    $("#cac-wrapper").html(result.cac);
                                    $(document).foundation('product', 'initCacListeners');
                                }
                            }
                        });
                    }

                    Foundation.libs.common.hidePreloader();
                }
                else if (result.IsUpdateCart === false && result.IsPopinConfirmation) {
                    $('#engraving-preview-modal').removeClass("o-engraving");
                    $('#engraving-preview-modal').addClass("small");
                    $('#engraving-preview-modal').html(result._PopinConfirmation);
                }
                else if (result.IsUpdateCart && result.IsPopinConfirmation === false) {
                    //$('#engraving-preview-modal').foundation('reveal', 'close');
                    //document.body.style.overflow = 'visible';

                    Foundation.libs.cartresume.updateComponent("etape1Panier", result._SectionTotalBasket);
                    Foundation.libs.cartresume.initBindings();
                    $('#product-engraving-popin').foundation('reveal', 'close');

                    Foundation.libs.cartcommon.InitGlobal();
                    $(document).foundation('common', 'refreshMasterTagData', result._MasterTagJson);
                    $(document).foundation('common', 'refreshMasterTag');

                    Foundation.libs.common.hidePreloader();
                }
            }
            else {
                if (result.Message != null && result.Message.length > 0) {
                    alert(result.Message);
                }

                Foundation.libs.common.hidePreloader();
            }
        },
        refreshSVGZone: function (zoneId) {
            var target = $("#" + zoneId);
            var templateId = target.data("template-id");
            var tspanId = target.data("tspan-id");
            var isAllCaps = target.data("is-all-caps") === "True";
            var template = document.querySelector("#engraving-preview-visual-" + templateId);
            var tspan = template.querySelector("#" + tspanId);
            var text = tspan.closest("text");
            var svg = text.closest("svg");
            var value = $("#" + zoneId).val()

            if (isAllCaps) {
                value = value.toUpperCase();
            }

            tspan.textContent = value;
            svg.removeChild(text);
            svg.appendChild(text);
        },
        refreshSVGZhdn: function (zoneId) {
            const heurePattern = zoneId.substring(0, zoneId.lastIndexOf("_"));
            var heures = $("#" + heurePattern + "_heure option:selected").val();
            var minutes = $("#" + heurePattern + "_min option:selected").val();

            if ((typeof heures != "undefined" && typeof minutes != "undefined") &&
                (heures.length > 0 && minutes.length > 0)) {
                $("#" + heurePattern).val(heures + "h" + minutes);
            }
            else {
                $("#" + heurePattern).val("");
            }
            Foundation.libs.gravure.refreshSVGZone(heurePattern);
        },
        refreshSVGZddn: function (zoneId) {
            const datePattern = zoneId.substring(0, zoneId.lastIndexOf("_"));
            const jour = $("#" + datePattern + "_jour option:selected").val();
            const mois = $("#" + datePattern + "_mois option:selected").val();
            const annee = $("#" + datePattern + "_annee option:selected").val();

            if ((typeof jour != "undefined" && typeof mois != "undefined" && typeof annee != "undefined") &&
                (jour.length > 0 && mois.length > 0 && annee.length > 0)) {
                $("#" + datePattern).val(jour + "." + mois + "." + annee);
            }
            else {
                $("#" + datePattern).val("");
            }
            Foundation.libs.gravure.refreshSVGZone(datePattern);
        },
        refreshSVGZcustom: function (zoneId) {
            const customPattern = zoneId.substring(0, zoneId.lastIndexOf("_"));
            let before = $("#" + customPattern + "_custom-before").val();
            let after = $("#" + customPattern + "_custom-after").val();
            const separator = $("#" + customPattern + "_custom_separator").text().trim();
            if (typeof after == "undefined") {
                after = "";
            }
            if (typeof before == "undefined") {
                before = "";
            }
            if (before.length > 0 || after.length > 0) {
                let out = before.concat(separator).concat(after).trim();
                $("#" + customPattern).val(out);
            }
            else {
                $("#" + customPattern).val("");
            }
            Foundation.libs.gravure.refreshSVGZone(customPattern);
        }
    };
}(jQuery, window, window.document));

